import '@components/assets/styles/app.scss';
import '@components/assets/styles/slick.scss';

import { registerFontAwesomeIcons } from '@wienenergiegithub/ui-next';

registerFontAwesomeIcons();

const Wrapper = ({ children }) => children;

export default Wrapper;
